module.exports = __webpack_public_path__ + "static/media/glorious-rome.8f6420d9.gif";